import { takeEvery, put, call } from "redux-saga/effects";
import {
  GET_ADDON_DT,

} from './actionTypes';

import {
  getAddOnDtOk,
  getAddOnDtErr,
} from './actions';

import {
  getAddOnsDt,
} from '~/helpers/backendHelper'


/********** DATATABLE **********/

function* onGetAddOnDt({ payload: { params } }) {
  try {
    const response = yield call(getAddOnsDt, params);
    yield put(getAddOnDtOk(response));
  } catch (error) {
    yield put(getAddOnDtErr(error));
  }
}

function* addOnSaga() {
  yield takeEvery(GET_ADDON_DT, onGetAddOnDt);
}

export default addOnSaga;